import { isEqual } from "lodash";
import appConstants from "../../../../../appConstants";
import constants from './constants';

const checkRouteMappingUpdated = ({
  originalRouteNames,
  routeNames,
  routeTypes,
  originalRouteTypes,
}) => {
  return (
    !isEqual(originalRouteNames, routeNames) ||
    !isEqual(routeTypes, originalRouteTypes)
  );
};

const isExistingRouteName = ({ routeMappingData, routeNames, routeType }) => {
  return routeMappingData.some((route) => {
    const secondaryRouteNames =
      route.secondaryRouteName?.toUpperCase().split(",") || [];
    return (
      route.type === routeType &&
      (routeNames.includes(route.primaryRouteName) ||
        secondaryRouteNames.some((routeName) => routeNames.includes(routeName)))
    );
  });
};

const isExistingRouteNameByType = ({
  routeMappingData,
  routeNames,
  routeType,
  routeTypes,
}) => {
  return (
    routeTypes.includes(routeType) &&
    isExistingRouteName({ routeMappingData, routeNames, routeType })
  );
};

const getPrimaryRouteOptions = (data) => {
  return data.primaryRoute
    ? {
        label: data.primaryRoute,
        value: data.primaryRoute,
      }
    : null;
};

const getRouteOptions = (data) => {
  return data?.map((item) => ({
    label: item,
    value: item,
  }));
};

const getRouteTypes = (isExistingFeature, editInfo) => {
  return Object.keys(appConstants.STOP_TYPE).map((key) =>
    isExistingFeature
      ? {
          value: appConstants.STOP_TYPE[key],
          labelText: appConstants.STOP_TYPE[key],
        }
      : {
          name: appConstants.STOP_TYPE[key],
          labelText: appConstants.STOP_TYPE[key],
          isChecked: editInfo.types.includes(appConstants.STOP_TYPE[key]),
        }
  );
};

const getCloneTargetType = (currentType) => {
  return currentType === appConstants.STOP_TYPE.Delivery
    ? appConstants.STOP_TYPE.Pickup
    : appConstants.STOP_TYPE.Delivery;
}

const getCloneTargetTypeLabel = (currentType) => {
  return currentType === appConstants.STOP_TYPE.Delivery
  ? constants.ROUTE_MAPPING_FILTER_OPTIONS[1].label
  : constants.ROUTE_MAPPING_FILTER_OPTIONS[2].label;
}

const getCloneConfirmationText = (currentType) => {
  const cloneTargetTypeLabel = getCloneTargetTypeLabel(currentType);
  return `Are you sure you want to copy selected ${currentType.toLowerCase()} zones for ${cloneTargetTypeLabel.toLowerCase()}?`;
}

const getExistingRouteNames = (routeMappingData, routeType) => {
  return routeMappingData.reduce((list, route) => {
    const secondaryRouteNames = route.secondaryRouteName?.split(",") || [];
    return route.type === routeType
      ? [...list, route.primaryRouteName, ...secondaryRouteNames]
      : [...list];
  }, []);
};

const getNonClonableZoneIds = (selectedZoneIds, clonableZoneIds) => {
  return selectedZoneIds.filter((zoneId) => !clonableZoneIds.includes(zoneId));
};

const getNonClonableZoneNames = (routeMappingData, nonClonableZoneIds) => {
  return routeMappingData
    .filter((routeMapping) =>
      nonClonableZoneIds.includes(routeMapping.routeMappingId)
    )
    .map((zone) => zone.primaryRouteName);
};

const getCloneIconTooltipText = ({
  currentType,
  selectedIds,
}) => {
  if (!selectedIds.length) {
    return "Select a route mapping to copy";
  }
  return `Copy ${currentType.toLowerCase()} zones for ${getCloneTargetTypeLabel(
    currentType
  ).toLowerCase()}`;
};

const getCloneAlertPopupMsg = (currentType) => {
  const targetCloneType = getCloneTargetType(currentType);
  return `${targetCloneType} zone already exists for the selected ${currentType.toLowerCase()} zones`;
}

const getDoorValue = (doorData) => {
  return doorData
    ? {
        label: doorData,
        value: doorData,
      }
    : null;
};

export {
  isExistingRouteName,
  isExistingRouteNameByType,
  checkRouteMappingUpdated,
  getPrimaryRouteOptions,
  getRouteOptions,
  getRouteTypes,
  getCloneConfirmationText,
  getCloneTargetType,
  getExistingRouteNames,
  getNonClonableZoneIds,
  getNonClonableZoneNames,
  getCloneTargetTypeLabel,
  getCloneIconTooltipText,
  getCloneAlertPopupMsg,
  getDoorValue
};
